import { MatchScheduleList } from "../shared/MatchSchedule";
import { ScheduleTeamFilter, ScheduleSeasonFilter } from "../schedule/MatchPageFilters";
import { RegularSeasonScoreboard } from "../teams/scoreboards/RegularSeasonScoreboard";
import { RoutePageMeta } from "../../seo/RoutePageMeta";
import { useResults } from "./hooks/useResults";

export const Results = () => {
  const {
    strings,
    currentSeason,
    selectedSeason,
    setSelectedSeason,
    standings,
    selectedTeamIds,
    seasonOptions,
    teamsInResults,
    filteredMatches,
    toggleTeam,
    clearTeamFilter,
    loading,
    hasSeasonMatches,
    teamFilterActive,
    showFilters,
  } = useResults();

  return (
    <section className="schedule-page">
      <RoutePageMeta page="RESULTS" />
      <div className="schedule-page-header">
        <h1 className="home-section-title">{strings.RESULTS.PAGE_TITLE}</h1>
        <p className="schedule-page-subtitle">{strings.RESULTS.PAGE_SUBTITLE}</p>
      </div>

      {showFilters && (
        <ScheduleSeasonFilter
          seasons={seasonOptions}
          selectedSeason={selectedSeason}
          currentSeason={currentSeason}
          onSeasonChange={setSelectedSeason}
          selectId="results-season-select"
        />
      )}

      {showFilters && (
        <div className="w-full">
          <RegularSeasonScoreboard teams={standings} />
        </div>
      )}

      {showFilters && hasSeasonMatches && (
        <ScheduleTeamFilter
          teams={teamsInResults}
          selectedTeamIds={selectedTeamIds}
          onToggleTeam={toggleTeam}
          onClear={clearTeamFilter}
        />
      )}

      {loading ? (
        <p className="schedule-page-status">{strings.RESULTS.LOADING}</p>
      ) : filteredMatches.length ? (
        <div className="schedule-page-matches">
          <h2 className="home-section-title mb-[clamp(0.75rem,1.5vw,1.25rem)]">
            {strings.RESULTS.MATCHES_TITLE}
          </h2>
          <MatchScheduleList matches={filteredMatches} mode="played" />
        </div>
      ) : (
        <div className="schedule-empty-card">
          <p className="schedule-empty-title">
            {teamFilterActive && hasSeasonMatches
              ? strings.RESULTS.NO_FILTER_RESULTS
              : selectedSeason
                ? strings.RESULTS.NO_SEASON_RESULTS
                : strings.RESULTS.NO_RESULTS}
          </p>
          <p className="schedule-empty-hint">
            {teamFilterActive && hasSeasonMatches
              ? strings.RESULTS.NO_FILTER_RESULTS_HINT
              : selectedSeason
                ? strings.RESULTS.NO_SEASON_RESULTS_HINT
                : strings.RESULTS.NO_RESULTS_HINT}
          </p>
        </div>
      )}
    </section>
  );
};

export const ResultsPage = () => {
  return <Results />;
};
